import React from 'react'
import TableRowCell from './TableRowCell'
import { TableFooterProps } from './ATTableProps'

const TableFooter: React.FC<TableFooterProps> = ({
  data,
  columns,
  footerColSpan,
  containsHeader,
}) => {
  const getData = (): any[] => {
    return containsHeader ? data?.slice(1) : data
  }
  const renderFooterHeader = (item: any): JSX.Element | undefined => {
    if (data?.length) {
      return containsHeader ? (
        <td
          className="text-end cell-highlight"
          colSpan={footerColSpan}
          key={`table-row-cell-footer-header`}
        >
          {data[0][item.key]}
        </td>
      ) : (
        <td colSpan={footerColSpan}></td>
      )
    }
  }
  return (
    <>
      {columns?.map((item, itemIndex) => (
        <tr key={`table-footer-${itemIndex}`}>
          {footerColSpan && renderFooterHeader(item)}
          {getData()?.map((column, columnIndex) => (
            <TableRowCell
              key={`table-row-cell-${columnIndex}`}
              item={column}
              column={item}
            />
          ))}
        </tr>
      ))}
    </>
  )
}

export default TableFooter
